import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import './style.scss';
import QuoteRequestService from '../../services/quote-request';
import BootstrapTable from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faLink, faEdit, faUndo } from '@fortawesome/free-solid-svg-icons';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from '../../helpers/date';
import Dialog from 'react-bootstrap-dialog';

const QuoteRequestList = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, current_page: 0 };
  const [filters, setFilters] = useState(defaultFilters);
  
  const [quoteRequest, setQuoteRequest] = useState([]);
  const [paginationLinks, setPaginationLinks] = useState([]);
  const [paginationMetaData, setPaginationMetaData] = useState({
    current_page: 0,
    from: 0,
    last_page: 0,
    path: "",
    per_page: 0,
    to: 0,
    total: 0
  });
  const [companies, setCompanies] = useState([]);
  const Data = [];
  const DataExp = [];
  let detailsArray = [];

  const [showModal, setShowModal] = useState(false);
  const [leadForComment, setLeadForComment] = useState({id: null, comments: null});

  const [update, setUpdate] = useState(true);

  useEffect(() => {
    if(update){
      listQuoteRequest();
    }
  }, [filters, update]);

  const listQuoteRequest = () => {

    let quoteRequestPromise = QuoteRequestService.getAll({ params: { ...filters }});
    quoteRequestPromise
      .then(result => {
        setPaginationMetaData(result.data.meta)
        setPaginationLinks(result.data.links)
        setQuoteRequest(renderData(result.data.data))
      })
      .catch(err => console.error("Err:" + err));
    quoteRequestPromise
      .then(result => setCompanies(renderDataCompanies(result.data.data)))
      .catch(err => console.error("Err:" + err));
  };

  const handleFilterChange = (new_filters, reset = false) => {

    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const renderData = info => {

    info.map((data, k) => {
      let link = "https://app.hubspot.com/contacts/4478780/deal/"+data.hubspot_id;
      Data.push({
        k: k,
        hubspot_id: data.hubspot_id,
        deal_name: data.deal_name,
        category_name: data.category_name +"/"+data.subcategory_name,
        manufacturers_name: data.manufacturers_name,
        deal_created_at: parseDateBR(data.deal_created_at),
        local_name: data.city_name + ' - ' + data.state_name,
        comments: data.comments,
        action: generateButtonsAction(data, link),
        btn: btn(k)
      });
    });

    return Data;
  }

  const generateButtonsAction = ({ id, hubspot_id, deal_created_at, recommended_companies, comments }, link) => {
    return (
      <div style={{width:'134px'}}>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip_hubspot_${id}`}>
              Ver no Hubspot
            </Tooltip>
          }
        >
          <Button href={link} className="font-12">
            <FontAwesomeIcon icon={faLink} id={hubspot_id}/>
          </Button>
        </OverlayTrigger>

        { new Date(deal_created_at) < new Date(new Date().getTime() - (24 * 60 * 60 * 1000))
          && recommended_companies.length == 0 
          && !comments 
          ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip_comments_${id}`}>
                Salvar motivo da não recomendação.
              </Tooltip>
            }
          >
            <Button 
              onClick={() => {
                setShowModal(true);
                setLeadForComment({ id, comments });
              }} 
              variant="info" className="font-12 ml-2"
            >
              <FontAwesomeIcon icon={faEdit}/>
            </Button>
          </OverlayTrigger>
        ) : (' ') }
        {new Date(deal_created_at) < new Date(new Date().getTime() - (24 * 60 * 60 * 1000))
        &&  recommended_companies.length == 0?(
          <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip_comments_${id}`}>
              Atualizar.
            </Tooltip>
          }
        >
          <Button 
            disabled={!update}
            onClick={(e) => {
              setUpdate(false);
              let btn = e.currentTarget;
              let div = btn.getElementsByTagName('div')[0];
              div.className = div.className+" rodar-icon";
              QuoteRequestService.update(id).then(()=>{
                setUpdate(true);
                div.className = div.className.replace(" rodar-icon","");
              });
            }} 
            variant="info" className="font-12 ml-2"
          >
            <div>
              <FontAwesomeIcon icon={faUndo} className={''}/>
            </div>
          </Button>
        </OverlayTrigger>
        ):''}
      </div>
    )
  }

  const saveComment = () => {
    QuoteRequestService.setComments(leadForComment)
      .then(() => {
        setShowModal(false);
        listQuoteRequest();
      })
  }

  const cancelSaveComment = () => {
    setShowModal(false);
    setLeadForComment(null);
  }

  const renderDataCompanies = info => {

    info.map((data, k) => {
      data.recommended_companies.map((company, i) => {
        DataExp.push({
          k: k,
          count: i + 1,
          name: company.name,
          alias: company.alias,
          address_state: company.address_state,
          address_city: company.address_city
        });
      });
    });

    return DataExp;

  }

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'hubspot_id',
      text: 'ID Hubspot',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'deal_name',
      text: 'Nome do Negócio',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'category_name',
      text: 'Categoria/Subcategoria',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'manufacturers_name',
      text: 'Fabricante',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'local_name',
      text: 'Local',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'deal_created_at',
      text: 'Data do Lead',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },

    {
      dataField: 'action',
      text: /*'Ver no Hubspot'*/ 'Ações',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center',
        verticalAlign: 'middle'
      }
    },
  ];

  const getRowCompanies = (companies, id, comments) => {
    if (companies.length == 0) return (
      <div className="container">
        <div className="row">
          <div className="col-sm text-center align-middle">
            { comments == "" ? 'Sem Recomendações' : comments}
          </div>
        </div>
      </div>
    )
    let companies_list = companies.map((company, k) => (
      <tr key={company.id}>
        <td>{company.count}</td>
        <td>{company.name}</td>
        <td>{company.alias ? company.alias : "--"}</td>
        <td>{company.address_state ? company.address_state : "--"}</td>
        <td>{company.address_city ? company.address_city : "--"}</td>
      </tr>
    ));
    return (
      <Table bordered hover responsive id={id}>
        <thead>
          <tr>
            <th>#</th>
            <th>Razão Social</th>
            <th>Nome Fantasia</th>
            <th>Estado</th>
            <th>Cidade</th>
          </tr>
        </thead>
        <tbody>
          {companies_list}
        </tbody>
      </Table>
    );
  };

  const getDetails = rowId => {
    detailsArray = [];
    var detail = { id: rowId, companies: [] };
    companies.map(company => {
      if (company.k == rowId) {
        detail.companies.push({
          count: company.count,
          name: company.name,
          alias: company.alias,
          address_state: company.address_state,
          address_city: company.address_city
        });
      }
    });
    detailsArray.push(detail);
  };

  const expandRow = {
    renderer: row => (
      <>
        {getDetails(row.k)}
        {btn_move(row.k)}
        {detailsArray.map(info => ( 
          getRowCompanies(info.companies, info.id, row.comments) 
        ))}
      </>
    )
  };

  function btn(id) {
    id = "btn-" + id;
    return <FontAwesomeIcon icon={faAngleRight} id={id}/>
  }

  const btn_move = id => {
    var btn = document.getElementById("btn-" + id);
    if (!btn.className.baseVal.includes("fa-rotate-90")) {
      btn.className.baseVal = btn.className.baseVal+"fa-rotate-90";
    } else {
      btn.className.baseVal = btn.className.baseVal.replace('fa-rotate-90', '');
    }
  }


  return (
    <>      
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col xs={6} className="align-self-center">
                    <h4 className={'headerTitle'}>
                      Solicitações de Orçamento
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={'line'} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}  className="d-flex justify-content-start">
                    <Form.Group>
                      <Form.Label>Registros por página:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.per_page}
                        onChange={e =>
                          handleFilterChange({ per_page: e.target.value, page: 1 })
                        }
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={{ offset: 5 }}></Col>
                  <Col xs={3} className="d-flex justify-content-end">
                    <Form.Group>
                      <Form.Label>Busca:</Form.Label>
                      <Form.Control
                        onChange={e =>
                          handleFilterChange({ search: e.target.value })
                        }
                        value={filters.search}
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <BootstrapTable
                  id="table"
                  keyField="hubspot_id"
                  data={quoteRequest}
                  columns={columns}
                  expandRow={expandRow}
                />
                <Row>
                  <Col>
                    <Trans i18nKey="label:interpolateShowingRecords">
                      Showing {{ from: paginationMetaData.from || '0' }} to{' '}
                      {{ to: paginationMetaData.to || '0' }} from {{ total: paginationMetaData.total }}{' '}
                      records
                    </Trans>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Pagination
                      activePage={paginationMetaData.current_page}
                      itemsCountPerPage={paginationMetaData.per_page}
                      totalItemsCount={paginationMetaData.total}
                      onChange={handlePageChange}
                      pageRangeDisplayed={5}
                      itemClass="page-item"
                      linkClass="page-link"
                      prevPageText="‹"
                      nextPageText="›"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal
          centered
          size="lg"
          show={showModal} 
          onHide={() => cancelSaveComment()}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Lead {`#${leadForComment ? leadForComment.id : ''}`} - Motivo da não recomendação
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              as="textarea"
              rows="4"
              onChange={(e) => setLeadForComment({ ...leadForComment, ...{ comments: e.target.value } })}
            >
              {leadForComment ? leadForComment.comments : ''}
            </Form.Control>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => cancelSaveComment()}>
              Cancelar
            </Button>
            <Button variant="success" onClick={() => saveComment()}>
              Salvar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default MasterPage(QuoteRequestList);